export class PCTableActionInputModel {
    constructor(buttons, title, fiels) {
        this.buttons = buttons;
        this.title = title;
        this.fiels = fiels;
    }

    public buttons: PCTableButtonModel[];
    public fiels: PCTableFieldModel[];
    public title: string;

}

export class PCTableButtonModel {
    constructor(name, className, icon) {
        this.name = name;
        this.className = className;
        this.icon = icon;
    }

    public name: string;
    public className: string;
    public icon: string;

}

export class PCTableFieldModel {
    constructor(
        name: string,
        fieldDatatype: string,
        label: string,
        isMandatory: boolean,
        isPrivate: boolean,
        isPassword: boolean,
        noEditable: boolean,
        isHide?: boolean,
    ) {
        this.name = name;
        this.fieldDatatype = fieldDatatype;
        this.label = label;
        this.isMandatory = isMandatory;
        this.isPrivate = isPrivate;
        this.isPassword = isPassword;
        this.noEditable = noEditable;
        if (isHide) {
            this.isHide=isHide;
        }else{
            this.isHide=false;
        }
    }

    public name: string;
    public fieldDatatype: string;
    public label: string;
    public defValue?: any;
    public pattern?: any;
    public isMandatory: boolean;
    public isPrivate: boolean;
    public isPassword: boolean;
    public noEditable: boolean;
    public isHide:boolean;
}